<script lang="ts">
	export let qnNumber: string;
	import QnComponent from './QnComponent.svelte';

</script>

<h2>Question {qnNumber}</h2>
<QnComponent/>
<hr>
